import { supabase } from './supabase'

// Her ayın 3'ünden itibaren: geçen ay(lar)da teslim edilen araçlar
// önce monats_statistik'e özetlenir, sonra silinir (historie FK cascade ile gider).
const CLEANUP_TAG = 3

export async function monatsCleanup() {
  const now = new Date()
  if (now.getDate() < CLEANUP_TAG) return

  const aktMonat = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`

  const { data: meta, error: metaErr } = await supabase
    .from('app_meta').select('value').eq('key', 'last_cleanup').maybeSingle()
  if (metaErr) {
    console.error('Cleanup: app_meta nicht lesbar', metaErr)
    return
  }
  if (meta?.value >= aktMonat) return // bu ay zaten çalıştı ('YYYY-MM' string karşılaştırması)

  const ersterDesMonats = `${aktMonat}-01`
  const { data: alte, error: ladeErr } = await supabase
    .from('fahrzeuge')
    .select('id, eingang, übergabe_datum, problem, fastcars, leihwagen_id')
    .eq('übergabe_ok', true)
    .lt('übergabe_datum', ersterDesMonats)
  if (ladeErr) {
    console.error('Cleanup: Fahrzeuge nicht lesbar', ladeErr)
    return
  }

  if (alte && alte.length > 0) {
    // 1. Ay bazında özetle
    const byMonat = {}
    alte.forEach(f => {
      const m = (f.übergabe_datum || '').substring(0, 7)
      if (!m) return
      if (!byMonat[m]) byMonat[m] = { abgeschlossen: 0, probleme: 0, fastcars: 0, dauerSum: 0, dauerN: 0 }
      const g = byMonat[m]
      g.abgeschlossen++
      if (f.problem) g.probleme++
      if (f.fastcars) g.fastcars++
      if (f.eingang) {
        g.dauerSum += (new Date(f.übergabe_datum) - new Date(f.eingang)) / 86400000
        g.dauerN++
      }
    })

    // 2. Varolan arşiv satırlarıyla birleştirip upsert et (ÖNCE arşivle, SONRA sil)
    const monate = Object.keys(byMonat)
    const { data: vorhandene } = await supabase
      .from('monats_statistik').select('*').in('monat', monate)
    const rows = monate.map(m => {
      const g   = byMonat[m]
      const alt = (vorhandene || []).find(v => v.monat === m)
      const altN   = alt?.abgeschlossen || 0
      const gesamtN = altN + g.abgeschlossen
      const dauerGesamt = (alt?.avg_dauer_tage || 0) * altN + g.dauerSum
      return {
        monat: m,
        abgeschlossen: gesamtN,
        probleme: (alt?.probleme || 0) + g.probleme,
        fastcars: (alt?.fastcars || 0) + g.fastcars,
        avg_dauer_tage: gesamtN > 0 ? Math.round((dauerGesamt / gesamtN) * 10) / 10 : 0,
      }
    })
    const { error: upsertErr } = await supabase.from('monats_statistik').upsert(rows)
    if (upsertErr) {
      console.error('Cleanup: Archivierung fehlgeschlagen — nichts wird gelöscht', upsertErr)
      return
    }

    // 3. Bağlı leihwagen'leri serbest bırak
    const lwIds = alte.filter(f => f.leihwagen_id).map(f => f.leihwagen_id)
    if (lwIds.length > 0) {
      await supabase.from('leihwagen').update({ verfügbar: true, vergeben_an: null }).in('id', lwIds)
    }

    // 4. Araçları sil (schritt_historie ON DELETE CASCADE)
    const { error: delErr } = await supabase
      .from('fahrzeuge').delete().in('id', alte.map(f => f.id))
    if (delErr) {
      console.error('Cleanup: Löschen fehlgeschlagen', delErr)
      return
    }
  }

  // 5. Guard güncelle — bir sonraki aya kadar tekrar çalışmaz
  await supabase.from('app_meta').upsert({ key: 'last_cleanup', value: aktMonat })
}
